export const getCmsPageType = (pageType: string): string => {
  const pageTypeMap: Record<string, string> = {
    "privacy-policy": "privacy_policy",
    "about-us": "about_us",
    "terms-conditions": "terms_conditions",
    "how-to-play": "how_to_play",
    "contact-us": "contact_us",
  };

  return pageTypeMap[pageType] || pageType;
};

export const formatPageTypeForDisplay = (pageType: string): string => {
  const displayMap: Record<string, string> = {
    privacy_policy: "Privacy Policy",
    about_us: "About Us",
    terms_conditions: "Terms & Conditions",
    how_to_play: "How to Play",
    contact_us: "Contact Us",
  };

  return displayMap[pageType] || pageType.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase());
};
